import { Directive, inject, input } from '@angular/core';
import { DropdownMenuComponent } from './dropdown-menu.component';
import { DropdownMenuService } from './dropdown-menu.service';

@Directive({
  selector: '[junoLibsUiDropdownMenu]',
  host: {
    '(click)': 'onClick($event)',
  },
})
export class DropdownMenuDirective {
  readonly junoLibsUiDropdownMenu = input.required<DropdownMenuComponent>();
  private dropdownMenusService = inject(DropdownMenuService);

  onClick(event: Event) {
    const junoLibsUiDropdownMenu = this.junoLibsUiDropdownMenu();
    this.dropdownMenusService.hideAllMenusExcept(junoLibsUiDropdownMenu.parentDropdown());
    event.stopPropagation();
    junoLibsUiDropdownMenu.toggleMenu();
  }
}
